function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "50%",
  y1: "100%",
  x2: "50%",
  y2: "0%",
  id: "Mobile_svg__a"
}, React.createElement("stop", {
  stopColor: "gray",
  stopOpacity: 0.25,
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "gray",
  stopOpacity: 0.12,
  offset: "54%"
}), React.createElement("stop", {
  stopColor: "gray",
  stopOpacity: 0.1,
  offset: "100%"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(.196 .142)",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M194.94 0H61.256a4.322 4.322 0 0 0-4.306 4.335v92.01a4.322 4.322 0 0 0 4.306 4.334h45.978v15.882h-2.096a2.191 2.191 0 0 0-2.183 2.2v3.186h4.28v1.885h41.727v-1.885h4.28v-3.187a2.191 2.191 0 0 0-2.184-2.199h-1.972v-.137h-.135v-15.745h45.99a4.322 4.322 0 0 0 4.305-4.335V4.334A4.322 4.322 0 0 0 194.94 0z",
  opacity: 0.7,
  fill: "#D0D7DD"
}), React.createElement("path", {
  fill: "#D0D7DD",
  d: "M107.638 97.944h41.184v24.288h-41.184z"
}), React.createElement("path", {
  d: "M108.449 100.32h39.644c.478-2.078.861-3.432.861-3.432h-41.448s.425 1.349.943 3.432z",
  opacity: 0.1,
  fill: "#7E828B"
}), React.createElement("path", {
  d: "M62.256.792h131.948a4.25 4.25 0 0 1 4.25 4.25v81.286H58.006V5.042a4.25 4.25 0 0 1 4.25-4.25z",
  fill: "#323C47"
}), React.createElement("path", {
  d: "M194.204 99.528H62.256a4.25 4.25 0 0 1-4.25-4.25v-8.95h140.448v8.95a4.25 4.25 0 0 1-4.25 4.25z",
  fill: "#D0D7DD"
}), React.createElement("circle", {
  fill: "#323C47",
  cx: 128.23,
  cy: 92.928,
  r: 2.376
}), React.createElement("path", {
  d: "M105.571 115.104h45.318c1.191 0 2.157.966 2.157 2.157v3.123h-49.632v-3.123a2.157 2.157 0 0 1 2.157-2.157z",
  fill: "#D0D7DD"
}), React.createElement("rect", {
  x: 0.19,
  y: 0.032,
  width: 87.12,
  height: 49.569,
  rx: 1.188,
  opacity: 0.5,
  transform: "translate(84.48 18.744)",
  fill: "url(#Mobile_svg__a)"
}), React.createElement("rect", {
  fill: "#FFF",
  x: 85.787,
  y: 19.14,
  width: 84.887,
  height: 48.565,
  rx: 1.188
}), React.createElement("rect", {
  fill: "#E0E0E0",
  x: 121.596,
  y: 26.112,
  width: 25.262,
  height: 1,
  rx: 0.467
}), React.createElement("rect", {
  fill: "#E0E0E0",
  x: 121.596,
  y: 28.921,
  width: 20.999,
  height: 1,
  rx: 0.467
}), React.createElement("rect", {
  fill: "#E0E0E0",
  x: 121.596,
  y: 39.212,
  width: 25.262,
  height: 1,
  rx: 0.467
}), React.createElement("rect", {
  fill: "#E0E0E0",
  x: 121.596,
  y: 42.018,
  width: 25.262,
  height: 1,
  rx: 0.467
}), React.createElement("rect", {
  fill: "#E0E0E0",
  x: 121.596,
  y: 52.312,
  width: 25.262,
  height: 1,
  rx: 0.467
}), React.createElement("rect", {
  fill: "#E0E0E0",
  x: 121.596,
  y: 55.118,
  width: 25.431,
  height: 1,
  rx: 0.42
}), React.createElement("path", {
  d: "M128.23 11.088V5.28M128.23 20.856v-7.622",
  stroke: "#6C63FF",
  strokeWidth: 0.66,
  fill: "#000"
}), React.createElement("circle", {
  fill: "#6C63FF",
  cx: 128.23,
  cy: 20.856,
  r: 1.056
}), React.createElement("circle", {
  stroke: "#FFF",
  strokeWidth: 0.66,
  cx: 128.23,
  cy: 12.144,
  r: 1.056
}), React.createElement("path", {
  d: "M128.23 11.088V5.28M128.23 20.856v-7.622",
  stroke: "#EB4235",
  strokeWidth: 0.66,
  fill: "#EB4235"
}), React.createElement("circle", {
  fill: "#EB4235",
  cx: 128.23,
  cy: 20.856,
  r: 1.056
}), React.createElement("circle", {
  stroke: "#FFF",
  strokeWidth: 0.66,
  cx: 128.23,
  cy: 12.144,
  r: 1.056
}), React.createElement("path", {
  d: "M128.23 73.656v8.184M128.23 66.264v7.622",
  stroke: "#EB4235",
  strokeWidth: 0.66,
  fill: "#EB4235"
}), React.createElement("circle", {
  fill: "#EB4235",
  cx: 128.23,
  cy: 66.264,
  r: 1.056
}), React.createElement("path", {
  d: "M80.71 44.484h-8.316M87.97 44.484h-7.622",
  stroke: "#EB4235",
  strokeWidth: 0.66,
  fill: "#EB4235"
}), React.createElement("circle", {
  fill: "#EB4235",
  cx: 87.97,
  cy: 44.484,
  r: 1.056
}), React.createElement("path", {
  d: "M107.77 114.972h41.184v1H107.77z",
  opacity: 0.1,
  fill: "#7E828B"
}), React.createElement("path", {
  d: "M47.309 96.904H28.195l.264-2.15c5.402-4.849 8.894-17.769 8.894-17.769a1.79 1.79 0 0 0-.23.048c-3.167.638-5.422 1.94-6.998 3.505l.67-5.718c9.98-2.149 13.937-15.349 13.937-15.349-6.368 1.413-10.338 3.599-12.804 5.674l.982-8.4c6.748 2.314 13.728-9.985 13.728-9.985l-.264-.056.132-.084-.2.071c-7.458-1.608-11.445 2.656-12.738 4.427l.097-.823c-.197.528-.389 1.045-.575 1.552v.021a90.995 90.995 0 0 0-1.45 4.24c-.382 1.191-.739 2.37-1.071 3.538v-.016s-.31-7.514-8.232-9.491c0 0 .832 16.386 7.11 13.704a124.322 124.322 0 0 0-1.468 6.883 112.702 112.702 0 0 0-.687 4.224l-.037.042.037-.032-.016.108a100.305 100.305 0 0 0-.448 3.638c.121-2.275-.293-8.849-8.04-15.027 0 0-10.295 18.095 7.26 21.648.04.035.08.07.117.1l-.026-.081.158.034.071-.929a97.519 97.519 0 0 0 .061 11.642l.055.78H7.152c-7.376 15.256 4.097 23.617 4.097 23.617h31.68c12.302-15.508 4.38-23.586 4.38-23.586z",
  opacity: 0.7,
  fill: "#D0D7DD",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M27.118 102.696s-5.016-21.912 6.072-50.16",
  stroke: "#535461",
  strokeWidth: 0.792,
  opacity: 0.6
}), React.createElement("path", {
  d: "M7.582 96.096H46.39s7.656 9.768-4.224 24.288H11.542S.454 110.352 7.582 96.096z",
  fill: "#4DA1FF"
}), React.createElement("path", {
  d: "M32.633 53.988s3.857-6.864 13.097-4.752c0 0-7.637 13.005-14.52 8.746l1.423-3.994zM30.188 61.272s-.298-7.02-7.954-8.868c0 0 .792 15.312 6.864 12.804l1.09-3.936zM27.686 71.639s1.412-7.355 16.196-10.523c0 0-4.715 15.212-16.877 14.602l.68-4.079z",
  fill: "#00BB6E"
}), React.createElement("path", {
  d: "M26.487 79.894s1.555-7.69-7.685-14.818c0 0-10.032 17.073 7.255 20.283l.43-5.465z",
  fill: "#00BB6E"
}), React.createElement("path", {
  d: "M26.21 90.465s-1.072-10.869 10.544-12.981c0 0-4.242 15.177-10.56 17.883l.016-4.902z",
  fill: "#00BB6E"
}), React.createElement("path", {
  d: "M31.342 58.08s10.032-7.656 14.256-8.976M26.986 75.636S39.13 62.7 43.882 61.116M22.234 52.404s7.392 10.032 6.864 12.672M18.802 65.076s3.96 17.952 7.128 20.328M26.194 95.436s6.336-17.424 10.56-17.952",
  stroke: "#535461",
  strokeWidth: 0.66,
  opacity: 0.3
}), React.createElement("path", {
  d: "M46.39 96.096H7.582c-.087.177-.172.354-.264.528H45.07s7.469 9.533-3.802 23.76h.898c11.88-14.52 4.224-24.288 4.224-24.288z",
  opacity: 0.1,
  fill: "#000"
}), React.createElement("path", {
  fill: "#E9EFF4",
  d: "M0 120.278h256.46v8.694H0zM10.866 128.972h234.725v3.556H10.866z"
}), React.createElement("path", {
  fill: "#7E828B",
  opacity: 0.1,
  d: "M10.866 128.972h234.725v1.185H10.866z"
}), React.createElement("path", {
  d: "M182.218 44.484h1.584",
  stroke: "#EB4235",
  strokeWidth: 0.66,
  fill: "#EB4235"
}), React.createElement("path", {
  d: "M168.226 44.484h11.848",
  stroke: "#EB4235",
  strokeWidth: 0.66,
  fill: "#000"
}), React.createElement("circle", {
  fill: "#EB4235",
  cx: 168.226,
  cy: 44.484,
  r: 1.056
}), React.createElement("circle", {
  stroke: "#FFF",
  strokeWidth: 0.66,
  cx: 181.162,
  cy: 44.484,
  r: 1.056
}), React.createElement("path", {
  d: "M240.958 117.448l.026-.04c.055-.084.109-.172.162-.263l.029-.05c.05-.087.099-.175.145-.264l.024-.045a6.28 6.28 0 0 0 .396-.977l.026-.087.069-.246.026-.116c.018-.074.033-.149.047-.224 0-.043.016-.085.024-.127.008-.042.024-.148.035-.224.01-.077 0-.088.015-.13.016-.042.016-.16.022-.243v-.113-22.163h-3.657V81.449h-4.488v10.687h-3.094V76.787h-4.488v15.349h-1.687V74.593h-4.488v17.543h-3.96v21.806c0 3.56 2.96 6.442 6.6 6.442h12.672a6.65 6.65 0 0 0 5.343-2.656c.066-.093.132-.186.201-.28z",
  opacity: 0.7,
  fill: "#D0D7DD"
}), React.createElement("path", {
  fill: "#323C47",
  d: "M220.63 84.744h4.224v26.4h-4.224z"
}), React.createElement("path", {
  fill: "#EB4235",
  d: "M220.63 76.032h4.224v8.712h-4.224z"
}), React.createElement("path", {
  fill: "#323C47",
  d: "M226.438 86.856h4.224v26.4h-4.224z"
}), React.createElement("path", {
  fill: "#FFD012",
  d: "M226.438 78.144h4.224v8.712h-4.224z"
}), React.createElement("path", {
  fill: "#323C47",
  d: "M233.566 91.344h4.224v26.4h-4.224z"
}), React.createElement("path", {
  fill: "#4DA1FF",
  d: "M233.566 82.632h4.224v8.712h-4.224zM216.934 92.928h24.288v20.988a6.204 6.204 0 0 1-6.204 6.204h-11.88a6.204 6.204 0 0 1-6.204-6.204V92.928z"
}), React.createElement("path", {
  d: "M216.934 92.928v1.056h23.232v20.988a6.175 6.175 0 0 1-1.32 3.825 6.19 6.19 0 0 0 2.376-4.881V92.928h-24.288z",
  opacity: 0.1,
  fill: "#4DA1FF"
}), React.createElement("rect", {
  x: 0.137,
  y: 0.24,
  width: 9.356,
  height: 8.422,
  rx: 1.188,
  opacity: 0.6,
  transform: "translate(109.296 25.872)",
  fill: "#EB4235"
}), React.createElement("rect", {
  x: 0.137,
  y: 0.04,
  width: 9.356,
  height: 8.422,
  rx: 1.188,
  transform: "translate(109.296 52.272)",
  fill: "#EB4235",
  opacity: 0.6
}), React.createElement("rect", {
  fill: "#EB4235",
  opacity: 0.6,
  x: 109.433,
  y: 39.212,
  width: 9.356,
  height: 8.422,
  rx: 1.188
}));

var SvgMobile = function SvgMobile(props) {
  return React.createElement("svg", _extends({
    width: 257,
    height: 133
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/Mobile.c7ca7f78.svg";
export { SvgMobile as ReactComponent };